import lf from 'lovefield';
import {thanksLogDB,tableNames} from '../indexedDB/lovefield.js';

const tableName = tableNames.members;

export default class Member{

    static getAllMembers(){
        return new Promise(function(resolve,reject){
            //order:nullを最後に持ってくるために、2段階にして連結
            //最初はオーダーのあるものをオーダー順に
            //次にnullのをid順にgetして連結

            try{
                const membersTable = thanksLogDB.getSchema().table(tableName);
                

                const getOrderdQuery = thanksLogDB.select()
                                                  .from(membersTable)
                                                  .where(membersTable.order.isNotNull())
                                                  .orderBy(membersTable.order, lf.Order.ASC);                    
                                               
                getOrderdQuery.exec().then((result) => {

                    const orderedMemberArray = result;

                    const getOrderNullQuery = thanksLogDB.select()
                                                         .from(membersTable)
                                                         .where(membersTable.order.isNull())
                                                         .orderBy(membersTable.id, lf.Order.ASC);
                    getOrderNullQuery.exec().then((result) => {
                        const orderNullMemberArray = result;

                        const allMemberArray = orderedMemberArray.concat(orderNullMemberArray);

                        resolve({
                            status:true,
                            data:allMemberArray
                        })
                    })
                })

            }catch(e){                 
                reject({
                    status:false,
                    message:'get error'
                })
            }
            
        })
    }

    // @param Member.id{Int}
    static getSpecificMember(id) {
        return new Promise(function(resolve,reject){

            try{
                const membersTable = thanksLogDB.getSchema().table(tableName);

                const getSpecificQuery = thanksLogDB.select()
                                                    .from(membersTable)
                                                    .where(membersTable.id.eq(id));

                getSpecificQuery.exec().then((result) => {
                    resolve({
                        status:true,
                        data:result[0]
                    })
                });

            }catch(e){                 
                reject({
                    status:false,
                    message:'get error'
                })
            }

        })
    }

    // @param Member{Object}
    static postMember(memberData){
        return new Promise(function(resolve,reject){

            try{

                const membersTable = thanksLogDB.getSchema().table(tableName);

                const memberToPost = membersTable.createRow(memberData);

                const postQuery = thanksLogDB.insertOrReplace()
                                             .into(membersTable)
                                             .values([memberToPost]);                    

                postQuery.exec().then((result) => {

                    resolve({
                        status:true,
                        data:result[0]
                    })
                    
                });

            }catch(e){                 
                reject({
                    status:false,
                    message:'post error'
                })
            }

        })
    }

    static orderMember(membersArray){
        return new Promise(function(resolve,reject){
            try {

                const membersTable = thanksLogDB.getSchema().table(tableName);

                let resultArray = [];

                for (let i = 0; i < membersArray.length; i++) {

                    membersArray[i].order = i + 1;

                    const memberToPost = membersTable.createRow(membersArray[i]);

                    const postQuery = thanksLogDB.insertOrReplace()
                                                .into(membersTable)
                                                .values([memberToPost]);                    

                    postQuery.exec().then((result) => {
                        resultArray.push(result[0]);
                    });
                  
                }

                resolve({
                    status:true,
                    data:resultArray
                })

            }catch(e){
                reject({
                    status:false,
                    message:'order post error'
                })
            }
        })
    }
    
    // @param Member.id{Int}
    static deleteMember(id) {
        return new Promise(function(resolve,reject){

            try{

                const membersTable = thanksLogDB.getSchema().table(tableName);

                const deleteQuery = thanksLogDB.delete()
                                               .from(membersTable)
                                               .where(membersTable.id.eq(id));                

                deleteQuery.exec().then((result) => {

                    resolve({
                        status:true,
                        data:result[0]
                    })
                });

            }catch(e){                 
                reject({
                    status:false,
                    message:'post error'
                })
            }
        })
    }


}